export default __webpack_public_path__ + "static/media/icon_bank.07c9a7d5.svg";